import React from 'react';

const Truncate = ({ children, lines = 1, ...props }) => {
  return (
    <div
      style={{
        display: '-webkit-box',
        WebkitLineClamp: lines,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
      }}
      {...props}
    >
      {children}
    </div>
  );
};

export default Truncate;
